import apiClient, { safeJson } from '@/api/client';
import { SaveNoshowAlwaysInResponse } from './types';

/**
 * @method put
 * @brief 상세 정산 「노쇼 수업은 항상 IN」 시작 달 저장 — 전용 API(예약 설정 PUT 에는 싣지 않는다).
 *
 * fromMonth: 'YYYY-MM'(켜기·시작 달 바꾸기) 또는 null(끄기). 키를 빼면 서버가 400 — 항상 싣는다.
 * 실패는 throw(err.status / err.body.errorCode). 구서버는 이 경로가 없어 404.
 */
export const putNoshowAlwaysIn = async ({ centerId, fromMonth }: { centerId: string; fromMonth: string | null }) => {
    const res = await apiClient.put(`v1/centers/${centerId}/reservation-rules/noshow-always-in`, {
        json: { fromMonth },
        // 정산 설정 요청은 401 자동 갱신·재전송을 끈다(예외 수업료 저장과 같은 관례 — 다른 탭의 새 로그인 토큰을 덮지 않게).
        noAuthRetry: true,
    } as any);
    return (await safeJson(res)) as SaveNoshowAlwaysInResponse | null;
};
